import { CheckCircleFilled } from '@ant-design/icons';
import { Alert, Button, Card } from 'antd';
import clsx from 'clsx';
import React, { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  title: string;
  children: ReactNode;
  className?: string;
  onCloseSuccess: () => void;
}

export default function FormSuccess({
  title,
  children,
  className,
  onCloseSuccess,
}: Props) {
  const { t } = useTranslation();

  return (
    <Card
      className={clsx('w-full self-center border-none', className)}
      classNames={{
        body: 'text-center flex flex-col items-center gap-10 -my-10',
      }}
    >
      <Alert
        showIcon
        icon={<CheckCircleFilled className="[&_svg]:!text-[24px]" />}
        className="w-full lg:w-3/4 self-center text-success px-6 py-4"
        type="success"
        message={title}
      />
      {children}
      <Button
        type="primary"
        size="large"
        onClick={onCloseSuccess}
        className="rounded-full"
      >
        {t('global:back_home')}
      </Button>
    </Card>
  );
}
